var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},[_c('p',{style:({ color: _vm.myColors.foreground })},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"progress-bar",style:({ 'border-color': _vm.myColors.main })},[_c('div',{staticClass:"fill",style:({ 'background-color': _vm.myColors.main, width: `${_vm.exp}%` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }